import type { useS4LContext } from '@s4l/react-context'
import { Money } from '@s4l/stayforlong/kernel/Money'
import { cn } from '@s4l/utility-css'
import React, { forwardRef } from 'react'
import styles from './index.module.css'
import { Typography } from '@s4l/ds'
import type { Markets } from '@s4l/stayforlong/shared/domain/Market'
import { Market } from '@s4l/stayforlong/shared/domain/Market'

interface ClusterProps {
  /**
   * The money in JSON
   */
  moneyJSON?: ReturnType<Money['toJSON']>
  /**
   * The number of properties in the cluster
   */
  count: number

  /**
   * The locale to use for the money formatting
   */
  i18n: ReturnType<typeof useS4LContext>['i18n']

  /**
   * The market
   */
  market: Markets
}

const Cluster = forwardRef<HTMLButtonElement, ClusterProps>(function Cluster(
  { moneyJSON, count, i18n, market },
  ref
) {
  const money = Money.fromJSONOrUndefined(moneyJSON)

  if (!money || !market || count < 1) return null

  let text: string

  try {
    text = money.toFormattedString(i18n.locale, Market.create({ value: market }))
  } catch {
    return null
  }

  return (
    <button ref={ref} type="button" className={cn(styles.cluster)}>
      <Typography variant="caption" size="l" bold>
        {i18n.formatMessage({ id: 'cluster-marker.text' }, { total: count, amount: text })}
      </Typography>
    </button>
  )
})

Cluster.displayName = 'Cluster'
export default Cluster
